export default `/* Ids Menu Group Component */
/**
 * Base Styles/Mixins for Ids Menu Component and all subcomponents.
 */
:host {
  display: block;
}

.ids-menu-group {
  display: block;
  margin-block-end: 0;
  margin-block-start: 0;
  padding-inline-start: 0;
}
.ids-menu-group.ids-menu-group-wrapped {
  display: flex;
  flex-flow: column wrap;
  max-height: 90vh;
  max-width: 100vw;
  width: max-content;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbWVudSIsInNvdXJjZXMiOlsiaWRzLW1lbnUtZ3JvdXAuc2NzcyIsImlkcy1tZW51LWJhc2Uuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQ0FBO0FBQUE7QUFBQTtBREdBO0VBQ0U7OztBQUdGO0VDRkU7RUFDQTtFQUNBO0VBQ0E7O0FER0E7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUtBIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIE1lbnUgR3JvdXAgQ29tcG9uZW50ICovXG5AdXNlICcuL2lkcy1tZW51LWJhc2UnIGFzICo7XG5cbjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG5cbi5pZHMtbWVudS1ncm91cCB7XG4gIEBpbmNsdWRlIHJlc2V0LW1lbnUtc3R5bGUoKTtcblxuXG4gICYuaWRzLW1lbnUtZ3JvdXAtd3JhcHBlZCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWZsb3c6IGNvbHVtbiB3cmFwO1xuICAgIG1heC1oZWlnaHQ6IDkwdmg7XG4gICAgbWF4LXdpZHRoOiAxMDB2dztcblxuICAgIC8vIE5PVEU6IFwid2lkdGg6IG1heC1jb250ZW50XCIgZG9lc24ndCB3b3JrIGluIFNhZmFyaSBhbmQgRmlyZWZveFxuICAgIC8vIFNvIGFkZGVkIFwiYWZ0ZXJzaG93XCIgbWVudSBldmVudCB0byBjb25maWd1cmUgd2l0aCBtYW51YWxseVxuICAgIC8vIEBzZWUgSWRzTWVudUdyb3VwLmNvbmZpZ3VyZU1lZ2FNZW51KClcbiAgICB3aWR0aDogbWF4LWNvbnRlbnQ7XG4gIH1cbn1cbiIsIi8qKlxuICogQmFzZSBTdHlsZXMvTWl4aW5zIGZvciBJZHMgTWVudSBDb21wb25lbnQgYW5kIGFsbCBzdWJjb21wb25lbnRzLlxuICovXG4vLyBSZXNldHMgdGhlIFVzZXItQWdlbnQgc3R5bGVzaGVldCBydWxlcyBmb3IgYDx1bD5gIGluIENocm9tZVxuQG1peGluIHJlc2V0LW1lbnUtc3R5bGUoKSB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtYXJnaW4tYmxvY2stZW5kOiAwO1xuICBtYXJnaW4tYmxvY2stc3RhcnQ6IDA7XG4gIHBhZGRpbmctaW5saW5lLXN0YXJ0OiAwO1xufVxuIl19 */`;
